import { createContext, useContext, type ReactNode } from 'react';
import type { BetSlipHandoffPort } from '@s2w/core';

const BetSlipContext = createContext<BetSlipHandoffPort | null>(null);

export interface BetSlipProviderProps {
  readonly port: BetSlipHandoffPort | null;
  readonly children: ReactNode;
}

export const BetSlipProvider = ({ port, children }: BetSlipProviderProps) => (
  <BetSlipContext value={port}>{children}</BetSlipContext>
);

export const useBetSlipPort = (): BetSlipHandoffPort | null => useContext(BetSlipContext);
